<template>
    <b-card body-class="p-0 mt-3">
        <!-- Details Dialog -->
        <b-card-header>
            <b-row>
                <b-col cols="12" class="text-right">
                    <b-button-group>
                        <b-button
                          id="service-list-filter-btn"
                            variant="blue-button me-2"
                            size="sm"
                            @click="shouldShowFilters = !shouldShowFilters"
                        >
                            <span style="white-space: nowrap">
                                {{ $translate('filters') }}
                                <b-icon
                                    :icon="`chevron-${
                                        shouldShowFilters ? 'up' : 'down'
                                    }`"
                                ></b-icon>
                            </span>
                        </b-button>
                        <b-button
                         id="service-list-filter-reset-btn"
                            variant="blue-button"
                            size="sm"
                            @click="resetFilters"
                            v-b-tooltip.hover
                            :title="$translate('reset_filters')"
                        >
                            <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                        </b-button>
                    </b-button-group>
                </b-col>

                <b-col class="text-right mb-2">
                    <slot></slot>
                </b-col>
            </b-row>
            <AssetServiceQueryFilter
                class="mt-12"
                :date-range="dateRangeIdx"
                v-show="shouldShowFilters"
                ref="queryFilter"
                v-model="filters"
                :disabled-officers="!hasPermissionView"
            />
            <b-col class="page-block"
                ><strong>
                    {{ $translate('page') }}: {{ currentPage }}
                    {{ $translate('of') }} {{ Math.ceil(rows / itemsPerPage) }}
                    {{ $translate('total') }}: {{ rows }}</strong
                ></b-col
            >
            <b-col class="overflow-auto w-100 mt-4"> </b-col>
        </b-card-header>
        <b-card-body>
            <b-table
                :fields="asset_order_fields"
                :per-page="itemsPerPage"
                :current-page="currentPage"
                responsive
                :items="items"
                :busy="loading"
            >
                
                <template #cell(id)="{ item: order }">
                    <router-link
                        class="btn btn-pink-button"
                        :to="`/ams/activities/${order.id}`"
                    >
                        <img src="@/assets/images/icon/view.svg" />
                    </router-link>
                </template>

                <template #cell(schedule_at)="{ value }">
                    {{ value | filterLocalDateTime }}
                </template>
                <template #cell(completed_at)="{ value }">
                    {{ value | filterLocalDateTime }}
                </template>
                <template #cell(driver_id)="{ value }">
                    {{ getOfficerName(value) }}
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right mt-3"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="itemsPerPage"
                        :next-text="$translate('next')"
                        :prev-text="$translate('previous')"
                        aria-controls="roleTable"
                        pills
                        align="center"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import AssetServiceQueryFilter from './AssetServiceQueryFilter.vue'
import permissionsMixins from '@/mixins/permissionsMixins'
import dateTimeMixins from '@/mixins/dateTimeMixins'
import moment from 'moment'

const defaultFilters = Object.freeze({
    completion_date_from: null,
    completion_date_to: null,
    status: null,
    due_from: null, // moment().startOf('month').format('YYYY-MM-DD'),
    due_to: null, // '9999-01-01', // moment().endOf('month').format('YYYY-MM-DD'),
})
const dateRangeEnum = {
    today: 0,
    yesterday: 1,
    custom: 2,
}
export default {
    name: 'assets-itemList',
    components: { AssetServiceQueryFilter },
    props: ['id', 'items', 'rows', 'title'],
    mixins: [popupMixins, permissionsMixins, dateTimeMixins],
    data() {
        return {
            query: '',
            reportType: 'service_item_details',
            itemsPerPage: 15,
            currentPage: 1,
            shouldShowFilters: false,
            dateRangeIdx: 2,
            loading: false,
            filters: { ...defaultFilters },
        }
    },

    mounted() {
        // if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    filters: {},
    computed: {
        user() {
            return this.$store.state.user
        },

        officers() {
            return this.$store.getters['users/sorted_officers']
        },
        queryModel() {
            const { query } = this
            return { query, ...this.filters }
        },
        asset_order_fields() {
            return [
                {
                    key: 'id',
                    label: this.$translate('actions'),
                },
                {
                    key: 'reference_no',
                    label: this.$translate('reference_no'),
                    formatter: value => value,
                },
                {
                    key: 'description',
                    label: this.$translate('description'),
                    formatter: value => value,
                },
                {
                    key: 'status',
                    label: this.$translate('status'),
                    formatter: (value, key, item) =>
                        item.completed == 1
                            ? this.$translate('completed')
                            : item.released == 1
                            ? this.$translate('released')
                            : this.$translate('pending'),
                },
                {
                    key: 'schedule_at',
                    label: this.$translate('due_date'),
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value), // tk: To be revisited
                },
                {
                    key: 'completed_at',
                    label: this.$translate('completion_date'),
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value), // tk: To be revisited
                },
                {
                    key: 'driver_id',
                    label: this.$translate('assigned_to'),
                },
            ]
        },
    },

    watch: {
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
        dateRangeIdx: function (val) {
            switch (val) {
                case dateRangeEnum.today:
                    this.$set(
                        this.filters,
                        'due_from',
                        moment().format('YYYY-MM-DD')
                    )
                    this.$set(
                        this.filters,
                        'due_to',
                        moment().format('YYYY-MM-DD')
                    )
                    break
                //due_to: moment().endOf('month').format('YYYY-MM-DD'),
                case dateRangeEnum.yesterday:
                    this.$set(
                        this.filters,
                        'due_from',
                        moment().subtract(1, 'days').format('YYYY-MM-DD')
                    )
                    this.$set(
                        this.filters,
                        'due_to',
                        moment().subtract(1, 'days').format('YYYY-MM-DD')
                    )
                    break
                default:
                    break
            }
            this.clearSelected()
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },

    methods: {
        getReportQuery(rpt_type) {
            const queryModel = {}
            queryModel.name = this.query
            queryModel.rpt_type = rpt_type
            return `&query=${btoa(JSON.stringify(queryModel))}`
        },
        getOfficerName(id) {
            const officer = this.officers.find(x => x.id == id)
            if (!officer) return ''
            return officer.name
        },
        formatDateTime(value) {
            const format1 = 'YYYY-MM-DD HH:mm'
            var date1 = new Date(value)
            return moment(date1).format(format1)
        },
        resetFilters() {
            this.filters = { ...defaultFilters }
            this.doSearch()
        },
        doSearch() {
            try {
                this.loading = true
                const id = this.id
                if (id == 0) return
                let { query, filters } = this
                this.$store
                    .dispatch('assets/fetchServiceHistory', {
                        query,
                        filters,
                        id,
                    })
                    .then(() => {
                        this.loading = false
                    })
            } catch (err) {
                console.error('loading error', err)
            }
        },

        //     try {
        //         this.loading = true
        //         const {
        //             query,
        //             pagination: { page },
        //             filters,
        //             crm,
        //             crmSettingValue: { type_id },
        //         } = this

        //         if (crm) {
        //             this.$set(filters, 'type_id', type_id || null)
        //             this.$set(filters, 'warranty_from', null)
        //             this.$set(filters, 'warranty_to', null)
        //         } else if (doReset) {
        //             this.$set(filters, 'type_id', null)
        //         }

        //         this.$set(filters, 'crm_type_id', type_id || null)

        //         await this.$store.dispatch('assets/fetch', {
        //             query,
        //             page,
        //             filters,
        //         })
        //     } catch (err) {
        //         console.error('loading error', err)
        //     } finally {
        //         this.loading = false
        //     }
        // },
    },
}
</script>
<style></style>
